import { getCommunityAPIProxy } from '../modules/community/api/index';
import { getCustomerAPIProxy } from '../modules/customer/api';
import { getEventAPIProxy } from '../modules/event/api/index';

export function getExportFileAccess(eventId?: string, communityId?: string, authTenantId?: string, filename?: string): Promise<{
    url: string;
    sas: string;
}> {
    if (eventId) {
        return getEventAPIProxy().getJson(`${eventId}/file/exportaccess?filename=${encodeURIComponent(filename)}`);
    }
    if (communityId) {
        return getCommunityAPIProxy().getJson(`${communityId}/file/exportaccess?filename=${encodeURIComponent(filename)}`);
    }
    if (authTenantId) {
        return getCustomerAPIProxy()
            .getJson(`audience/${authTenantId}/file/exportaccess?filename=${encodeURIComponent(filename)}`);
    }

    throw new Error("Not implemented");
}
